import { TReduxActions } from '../../../types/redux';
import { EInfrastructureActionTypes } from '../../../actions/newReview';
import { TInfrastructureRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue = {
  value: 0,
};

export function infrastructureRatingReducer(
  state: TInfrastructureRating = defaultValue,
  { type, payload }: TReduxActions,
): TInfrastructureRating {
  if (type === EInfrastructureActionTypes.SetRating) {
    return {
      value: payload,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
